import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import WebMenu from "../Pages/Shared/WebMenu";
import Footer from "../Pages/Shared/Footer";

function PublicRoute() {
  const pathname = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      <WebMenu />

      <Suspense
        fallback={
          <div className="loader">
            <CircularProgress sx={{ color: "#86c65a" }} />
          </div>
        }
      >
        <Outlet />
      </Suspense>

      <Footer />
    </>
  );
}

export default PublicRoute;
